import type { ClipboardEventHandler } from "react";

export enum TextboxType {
  Text,
  Password,
  Email,
  Number,
  Telephone,
  Search,
}

export enum TextboxAppearance {
  Standard,
  Search,
  SearchWhite,
  SearchGray,
  SearchProducts,
  SearchGlobal,
  Round,
  PrefixNumber,
}

export enum TextboxAppearanceV2 {
  Standard,
  Round,
  PrefixNumber,
}

export const defaultFalse: ClipboardEventHandler<HTMLElement> = (ev) =>
  ev.preventDefault();

export type InputTypes = "text" | "password" | "email" | "number" | "tel" | "search";

export const getInputType = (type?: TextboxType) => {
  switch (type) {
    case TextboxType.Password:
      return "password";
    case TextboxType.Email:
      return "email";
    case TextboxType.Number:
      return "number";
    case TextboxType.Telephone:
      return "tel";
    case TextboxType.Search:
      return "search";
    case TextboxType.Text:
    default:
      return "text";
  }
};
